
<div >
    <div class="row ">
        <div class="col ps-3">
            <h4 class="mb-0 font-header" style="font-weight: 700;">Authorization Logs</h4>
        </div>
    </div>
    <div *ngIf="global.globalAgencyId == null || global.globalAgencyId == undefined || global.globalAgencyId == '00000000-0000-0000-0000-000000000000' || global.globalAgencyId == 0|| this.global.globalAgencyId == '' ">
        <div class="row mt-4">
          <div class="col">
            <div class="card border-0 box-shadow">
              <div class="card-body widget-body pt-2">
                <div class="text-center text-danger">
                  <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                    details</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div class="row mt-4"
    *ngIf="global.globalAgencyId != null && global.globalAgencyId != '' && global.globalAgencyId != undefined && global.globalAgencyId != '00000000-0000-0000-0000-000000000000'">

        <div class="col ">


            <div widget class="card border-0 box-shadow">
                <div class="row mt-2 p-4">
                    <div class="col-lg-3">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">From<sup class="super-script">*</sup> </label>
                        </div>
                        <div class="col-lg-12">
                            <my-date-picker [options]="myDatePickerOptions" [selDate]="FilterDates.FromDate"
                                placeholder="mm/dd/yyyy"
                                (inputFieldChanged)="newdates($event,'inputchanged','FromDate')"
                                (dateChanged)="newdates($event,'datechanged','FromDate')">
                            </my-date-picker>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">To<sup class="super-script">*</sup></label>
                        </div>
                        <div class="col-lg-12">
                            <my-date-picker [options]="myDatePickerOptions" [selDate]="FilterDates.ToDate"
                                placeholder="mm/dd/yyyy" [disabled]="FilterDates.FromDate==null||
                            FilterDates.FromDate==undefined|| FilterDates.FromDate==''"
                                (inputFieldChanged)="newdates($event,'inputchanged','ToDate')"
                                (dateChanged)="newdates($event,'datechanged','ToDate')">
                            </my-date-picker>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">Auth Import Status </label>
                        </div>
                        <div class="col-lg-12">
                            <select [(ngModel)]="AuthImportStatus" class="form-control">
                                <option value= "">All</option>
                                <option value="Success">Success</option>
                                <option value="Failed">Failed</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-lg-3" *ngIf="getClientNames.length>0">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">Client </label>
                        </div>
                        <div class="col-lg-12">
                            <ng-select [(ngModel)]="ListClientFilter" [searchable]="true" [clearable]="true"
                                [items]="getClientNames" bindLabel="Value" bindValue="Value">
                            </ng-select>
                        </div>
                    </div>
                    
                </div>
                <div class="row pe-4">

                    <div class="col-lg-12 text-end">
                        <div class="col-lg-12">
                            <label style="font-weight:bold"></label>
                        </div>
                        <div class="col-lg-12 ">
                            <button type="button" class="btn blue-btn btn-sm ms-2" [disabled]="FilterDates.FromDate==null || FilterDates.FromDate==undefined ||
                            FilterDates.FromDate=='' ||
                            FilterDates.ToDate==null || FilterDates.ToDate==undefined ||
                            FilterDates.ToDate==''
                            " (click)="ApplyFilter()">Apply
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card-body  widget-body p-4">
                    <ejs-grid #gridSFTPLogs [dataSource]='GridDataList | async' [allowResizing]='true'
                        [allowSorting]='true' (resizeStop)="onResize($event)" [allowPaging]='true'
                        [pageSettings]='initialPage' [filterSettings]='filterSettings' [allowFiltering]='true'
                        (actionBegin)="onActionComplete($event)" [showColumnChooser]='true'
                        (dataStateChange)='dataStateChange($event)'>
                        <e-columns>
                            <!-- Client Name -->
                            <e-column width=150 field="recipientName" headerText="Client Name" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>

                            <!-- Insurance Number -->
                            <e-column width=150 field="recipientId" headerText="Insurance Number" type="string"
                                [allowSorting]='false' [allowFiltering]="false">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- Provider Number -->
                            <e-column width=150 field="providerNo" headerText="Provider Number" type="string"
                                [allowSorting]='false' [allowFiltering]="false">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- Company -->
                            <e-column width=150 field="companyName" headerText="Company" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- Start Date -->
                            <e-column width=150 field="startDate" headerText="Start Date" type='date'
                                [allowSorting]='false' [allowFiltering]="false" [format]='formatOptions'></e-column>
                            <!-- End Date -->
                            <e-column width=150 field="endDate" headerText="End Date" type='date'
                                [allowSorting]='false' [allowFiltering]="false" [format]='formatOptions'></e-column>
                            <!-- Payor -->
                            <e-column width=150 field="payorName" headerText="Payor" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- Service Code -->
                            <e-column width=150 field="procedureCode" headerText="Service Code" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- Import Date -->
                            <e-column width=150 field="importedOn" headerText="Import Date" type='date'
                                [allowSorting]='false' [allowFiltering]="false" [format]='formatOptions'></e-column>
                            <!-- File Import Status -->
                            <e-column width=150 field="authFileImportStatus" headerText="File Import Status"
                                type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <e-column width=200 field="fileName" headerText="File Name" 
                                type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- File Import Error -->

                            <e-column field="authFileErrorMessage" headerText="File Import Error" width="150"
                                textAlign='center' [allowEditing]='false' type='string' [allowSorting]='false'
                                [allowFiltering]="false">
                                <ng-template #template let-data>
                                    <button class="btn btn-edit-table text-center" data-bs-toggle="modal"
                                    [disabled]="data.authFileErrorMessage==null || data.authFileErrorMessage==undefined || data.authFileErrorMessage==''"
                                        data-bs-target="#showError"
                                        (click)="getError(data.authFileErrorMessage)">View</button>&nbsp;
                                </ng-template>
                            </e-column>
                            <!-- "Auth Import Status -->
                            <e-column width=150 field="authDetailImportStatus" headerText="Auth Import Status"
                                type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- Auth Import Error -->
                            <e-column field="authDetailErrorMessage" headerText="Auth Import Error" width="150"
                                textAlign='center' [allowEditing]='false' type='string' [allowSorting]='false'
                                [allowFiltering]="false">
                                <ng-template #template let-data>
                                    <button class="btn btn-edit-table text-center" data-bs-toggle="modal"
                                        [disabled]="data.authDetailErrorMessage==null || data.authDetailErrorMessage==undefined || data.authDetailErrorMessage==''"
                                        data-bs-target="#showError"
                                        (click)="getError(data.authDetailErrorMessage)">View</button>&nbsp;
                                </ng-template>
                            </e-column>
                            <!-- settings -->
                            <e-column width="50" [showInColumnChooser]='false'>
                                <ng-template #headerTemplate let-data>
                                    <div class="d-none d-lg-block">
                                        <span id='show' (click)='show()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                                            </i></span>
                                    </div>
                                </ng-template>
                            </e-column>
                        </e-columns>
                    </ejs-grid>
                    <div *ngIf="SFTPData.length == 0  && global.globalAgencyId != 0" class="text-center"
                        style="color:red">
                        <p>No data available</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<span id="openError" data-bs-toggle="modal" data-bs-target="#showError"></span>
<div class="modal hide fade modalbackgrod" id="showError" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Error </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body ">
                <div class="row">
                    <div class="col-lg-12 ">
                        <textarea class="form-control" style="height: 256px;" [(ngModel)]="RequestPayload"></textarea>

                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm " data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>